// This entrypoint was manually created to wrap the tokens.js/tokens.cjs files generated by style-dictionary. The exports below allow consumers to import default or named imports:
//
// import Tokens from '@zapier/design-tokens';
// import { ColorTeal2 } from '@zapier/design-tokens';
//

import * as Tokens from './tokens.js';
export * from './tokens.js';

export default Tokens;
